var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-editor"},[_c('vue-editor',{attrs:{"value":_vm.value,"editor-toolbar":_vm.editorOptions.toolbar},on:{"input":_vm.onEditorChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }